/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useAcesFlags } from '@/features/ymme/utils/acesFlags';
import { getExperimentId } from './getExperimentId';
import { useForteDecisionFlag } from '@/features/forte/api/getForteDecision';

/**
 * Hook to get normalized experimentId with fallback logic and ACES awareness.
 * Reads ACES flag internally.
 *
 * @returns Normalized experimentId or undefined
 */
export function useExperimentId(): 'elasticsearch' | 'vertex' | undefined {
  const rawExperimentId = useForteDecisionFlag('experimentId');
  const { acesEnabled } = useAcesFlags();
  return getExperimentId(rawExperimentId, acesEnabled);
}
